import {Component, OnInit} from '@angular/core';
import {TituloComponent} from '../titulo/titulo.component';
import {ButtonComponent} from '../shared/components/button/button.component';
import {FormFieldComponent} from '../shared/components/form-field/form-field.component';
import {Usuario} from '../shared/model/usuario.model';
import {AuthServiceService} from '../shared/service/auth-service.service';
import {MatDialog} from '@angular/material/dialog';
import {ModalConfirmacaoComponent} from '../shared/components/modal-confirmacao/modal-confirmacao.component';
import { MsgServiceService } from '../shared/service/msg-service.service';
import {AlterarSenha} from '../shared/model/alterarSenha.model';

@Component({
  selector: 'app-perfil',
  imports: [
    TituloComponent,
    ButtonComponent,
    FormFieldComponent
  ],
  templateUrl: './perfil.component.html',
  styleUrl: './perfil.component.css'
})
export class PerfilComponent implements OnInit{
   usuario: Usuario = new Usuario();
   mostrarCamposSenha: boolean = false;
   novaSenha: AlterarSenha = new AlterarSenha();

  constructor(
    private authService: AuthServiceService,
    private dialog: MatDialog,
    private msgService: MsgServiceService,
  ) {}

  ngOnInit(): void {
    this.usuario = this.recuperaDadosUsuario() ?? new Usuario();
  }

   toggleAlterarSenha() {
    this.mostrarCamposSenha = !this.mostrarCamposSenha;
    if (!this.mostrarCamposSenha) {
      this.limparCamposSenha();
    }
  }

   cancelarAlteracaoSenha() {
    this.mostrarCamposSenha = false;
    this.limparCamposSenha();
  }

   abrirDialogConfirmacao() {
    if (!this.validarSenhas()) {
      return;
    }

    const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      width: '380px',
      height: '178px',
      data: { mensagem: 'Deseja confirmar a troca de senha?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.alterarSenha();
      }
    });
  }

 alterarSenha() {
    this.novaSenha.idUsuario = this.usuario.id;

    this.authService.alterarSenha(this.novaSenha).subscribe({
      next: (response) => {
        this.msgService.msgSucesso('Senha alterada com sucesso!');
        this.mostrarCamposSenha = false;
        this.limparCamposSenha();
      },
      error: (error) => {
        this.msgService.msgErro( error.error);
      }
    });
  }

  private validarSenhas(): boolean {
    const senhaAtual = this.novaSenha.senhaAtual?.trim();
    const novaSenha = this.novaSenha.novaSenha?.trim();
    const confirmarSenha = this.novaSenha.confirmarSenha?.trim();

    const regras: Array<{ invalido: boolean; msg: string }> = [
      { invalido: !senhaAtual, msg: 'Informe a senha atual' },
      { invalido: !novaSenha, msg: 'Informe a nova senha' },
      { invalido: !confirmarSenha, msg: 'Informe a confirmação da nova senha' },
      { invalido: !!novaSenha && !!confirmarSenha && novaSenha !== confirmarSenha, msg: 'As senhas não conferem' },
      { invalido: senhaAtual === novaSenha, msg: 'A nova senha não pode ser igual a atual' }
    ];

    const erro = regras.find(r => r.invalido);
    if (erro) {
      this.msgService.msgAdvertencia(erro.msg);
      return false;
    }
    return true;
  }

  private limparCamposSenha() {
    this.novaSenha = new AlterarSenha();
  }

  sair() {
    this.authService.logout();
  }

  recuperaDadosUsuario(){
    const parceiroLogado = localStorage.getItem('parceiro');
    return parceiroLogado ? JSON.parse(parceiroLogado) as Usuario: null;
  }
}
